import { render, staticRenderFns } from "./MyRecibos.vue?vue&type=template&id=bdffb59e"
import script from "./MyRecibos.vue?vue&type=script&lang=js"
export * from "./MyRecibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports